import { router } from './router';
import { defaults } from './options';
export const manhattan = function (vertices, options, edgeView) {
    return router.call(this, vertices, Object.assign(Object.assign({}, defaults), options), edgeView);
};
//# sourceMappingURL=index.js.map